import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import TaskInvoicesTable from './TaskInvoicesTable';
import { NO_CHARGES_POSTED } from '../../../utils/taskInvoice';

// Invoices for a task's posted charges, with PDF / Print per invoice.
const TaskInvoicesModal = ({ show, handleCancel, taskId, taskTitle = '', invoices, loading = false }) => (
    <Modal
        size="lg"
        className="topUpModal productskuListing carrier-reconciliation-modal"
        backdrop="static"
        show={show}
        onHide={handleCancel}
    >
        <div className="top_modal_header_container no_mrg">
            <div>
                <span>Invoices - Task # {taskId}{taskTitle ? ` (${taskTitle})` : ''}</span>
            </div>
            <div className="modalDeleteWrapper">
                <button type="button" onClick={handleCancel} className="btn-close" aria-label="Close"></button>
            </div>
        </div>
        <div className="modal_container_rate_card pb-3 productList">
            <TaskInvoicesTable invoices={invoices} loading={loading} emptyText={NO_CHARGES_POSTED} />
        </div>
    </Modal>
);

TaskInvoicesModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleCancel: PropTypes.func.isRequired,
    taskId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    taskTitle: PropTypes.string,
    invoices: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool,
};

export default TaskInvoicesModal;
